import { Moon, Sun } from 'lucide-react';
import { cn } from '../utils/cn';

export interface ThemeToggleProps {
  theme: 'light' | 'dark';
  onToggle: () => void;
  mounted?: boolean;
  className?: string;
}

export function ThemeToggle({ theme, onToggle, mounted = true, className }: ThemeToggleProps) {
  const baseClasses = cn(
    'relative flex h-9 w-9 items-center justify-center rounded-lg border transition-all duration-200',
    'border-border-default bg-bg-elevated text-text-secondary hover:bg-bg-muted hover:text-text-primary shadow-soft',
    'dark:border-border-default dark:bg-bg-elevated dark:text-text-muted dark:hover:bg-bg-subtle dark:hover:text-text-inverse',
  );

  if (!mounted) {
    return (
      <button className={cn(baseClasses, className)} aria-label="Toggle theme" disabled>
        <span className="h-4 w-4" />
      </button>
    );
  }

  return (
    <button
      onClick={onToggle}
      className={cn(baseClasses, className)}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      title={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <Sun
        className={cn(
          'h-4 w-4 absolute transition-all duration-300',
          theme === 'dark' ? 'rotate-0 scale-100 opacity-100' : 'rotate-90 scale-0 opacity-0',
        )}
      />
      <Moon
        className={cn(
          'h-4 w-4 absolute transition-all duration-300',
          theme === 'light' ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0',
        )}
      />
    </button>
  );
}
